import React from 'react'
import { connect } from 'react-redux'
import PropTypes from "prop-types"
import { Modal, FormControl } from "react-bootstrap"

import Button from '../../components/Button'

import { createTripNote } from '../../ducks/trips'
import { getText } from '../../lib/text.js'
import { getStatusLabel } from '../../trips/TripStatus'

const Props = {
  username: PropTypes.string.isRequired,    // from connect
  onButtonClick: PropTypes.func.isRequired, // from daddy
  tripId: PropTypes.string.isRequired,      // from promptsMiddleware, via daddy
  tripName: PropTypes.string.isRequired,    // from promptsMiddleware, via daddy
  tripStatus: PropTypes.string.isRequired,  // from promptsMiddleware, via daddy
}

class _ExplanationPrompt extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = {
      text: ""
    }
  }

  props: Props

  render() {
    return (
      <Modal show onHide={() => this.props.onButtonClick(null)}>
        <Modal.Header>
          <Modal.Title>
            Añade una breve explicación
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Qué ha pasado? ¿Por qué <i>{this.props.tripName}</i> está {getStatusLabel(this.props.tripStatus)}?</p>
          <FormControl
            componentClass="textarea"
            value={this.state.text}
            onChange={evt => this.setState({ text: evt.target.value })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            glyph="remove-sign"
            onClick={() => this.props.onButtonClick(null)}
          >
            {getText("Cambiar sin explicación")}
          </Button>
          <Button
            bsStyle="primary"
            glyph="ok"
            disabled={!this.state.text}
            onClick={() => this.props.onButtonClick(
              createTripNote(this.props.tripId, {
                author: this.props.username,
                text: this.state.text,
                pinned: true,
              })
            )}
          >
            {getText("Guardar explicación")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const stateToProps = state => ({
  username: state.loginData.username
})

export default connect(stateToProps)(_ExplanationPrompt)
